<script>
import { http } from '@/common/http/index';
import { userStorage } from '@/hooks/useStorage';
import { expireSession } from '@/common/auth/session';

const { getStorage } = userStorage();
let sessionTimer = null;
let checkingSession = false;

const checkSession = async () => {
	const token = getStorage('token');
	if (!token || checkingSession) return;
	checkingSession = true;
	try {
		const res = await http.post('/app/auth/checkone', {}, { custom: { toast: false } });
		if (res.code == 1 && res.data == 1) {
			expireSession(token, '当前账号已在其他设备登录，请重新登录');
		}
	} catch (err) {
		// 未登录响应由请求拦截器处理；网络失败时保留本地登录状态。
	} finally {
		checkingSession = false;
	}
};

export default {
	onLaunch: function () {
		// 锁定竖屏正方向
		// #ifdef APP
		// plus.screen.lockOrientation('landscape-primary');
		// #endif
	},
	onShow: function () {
		if (sessionTimer !== null) clearInterval(sessionTimer);
		checkSession();
		sessionTimer = setInterval(checkSession, 15000);
	},
	onHide: function () {
		if (sessionTimer !== null) clearInterval(sessionTimer);
		sessionTimer = null;
	}
};
</script>

<style lang="scss">
/*每个页面公共css */
@import '@/uni_modules/uv-ui-tools/index.scss';
@import '@/static/index.css';
@import '@/static/answer.scss';
page {
	background-color: #f5f5f5;
}
.hengColor {
	color: #002288;
}
// button 全局样式
.uv-button {
	border-radius: 14rpx !important;
	.uv-button__text {
		color: #fff;
		font-size: 25rpx !important;
	}
}
.htmlbox {
	:deep(._img) {
		max-width: 200rpx !important;
		min-height: 150rpx;
		object-fit: contain;
	}
}
:deep(.uv-button--info) {
	color: #fff !important;
	background-color: #002288 !important;
}

:deep(.uv-button--plain) {
	background: none !important;
	.uv-button__text {
		color: #002288;
	}
}

:deep(.input-placeholder) {
	color: #999999 !important;
	font-size: 28rpx;
}

:deep(.uv-input__content__prefix-icon) {
	margin-right: 0 !important;
}
</style>
